import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const badge = (props) => {
  const { title } = props;

  return (
    <span className="iDEAL-Badge badge badge-danger">{title}</span>
  );
};


badge.propTypes = {
  title: PropTypes.string.isRequired,
};

export default badge;
